import * as CONSTANTS from '@/store/constants.js'
//import moment = require('moment');

const state = {
  drawer: false,
  ambient: CONSTANTS.AMBIENT_LIGHT,
  loading: false,
  loading_message: '',
  ajax: false,
  search: '',
  day: null,
  activeCategory: null,
  mobileOrderExpanded: false
}

const getters = {
  drawer: (state) => state.drawer,
  ambient: (state) => state.ambient,
  ajax: (state) => state.ajax,
  search: (state) => state.search,
  day: (state) => state.day,
  activeCategory: (state) => state.activeCategory,
  mobileOrderExpanded: (state) => state.mobileOrderExpanded,
}

const actions = {

}

const mutations = {
  toggle_drawer: (state) => {
    state.drawer = !state.drawer
  },
  open_drawer: (state) => {
    state.drawer = true
  },
  close_drawer: (state) => {
    state.drawer = false
  },
  ambient: (state, payload) => {
    state.ambient = payload
  },
  app_loading: (state, payload) => {
    state.loading_message = payload
  },
  app_loading_message: (state, payload) => {
    state.loading = payload
  },
  ajax_running: (state, payload) => {
    state.ajax = payload
  },
  search: (state, payload) => {
    state.search = payload
  },
  day: (state, payload) => {
    state.day = payload
  },
  activeCategory: (state, payload) => {
    state.activeCategory = payload
  },
  mobileOrderExpanded: (state, payload) => {
    state.mobileOrderExpanded = payload
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
